import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { SignOut } from "@phosphor-icons/react";
import { useAuth } from "../lib/auth";
import { useRbac } from "../lib/rbac";
import { NAV } from "../lib/navMatrix";
import PreviewBanner from "./PreviewBanner";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const { hasAny, isSuperAdmin, roleIds, loaded } = useRbac();
  const navigate = useNavigate();

  // Only render items the user has permission to see. Empty `anyOf`
  // means "auth_only" — visible to any staff user.
  const visibleNav = NAV.filter((n) => {
    if (!n.anyOf || n.anyOf.length === 0) return true;
    return hasAny(...n.anyOf);
  });

  const roleSummary = isSuperAdmin
    ? "Super Admin"
    : (roleIds && roleIds.length > 0 ? roleIds.map((r) => r.replace(/^role_/, "").replace(/_/g, " ")).join(", ") : "No roles");

  return (
    <div className="flex min-h-screen" data-testid="admin-layout">
      <aside className="gf-sidebar">
        <div className="gf-sidebar-brand" onClick={() => navigate("/dashboard")} role="button">
          GetFuel<span className="dot">.</span>
        </div>
        <div className="section-label">OPERATIONS</div>
        <nav data-testid="admin-nav">
          {loaded && visibleNav.map((n) => (
            <NavLink
              key={n.path}
              to={n.path}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <n.icon size={16} weight="regular" />
              <span>{n.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="gf-sidebar-footer">
          <div className="text-xs font-mono text-zinc-400">SIGNED IN AS</div>
          <div className="text-sm text-white truncate" data-testid="admin-user-name">
            {user?.name}
          </div>
          <div className="text-xs text-zinc-500 truncate">{user?.email}</div>
          <div className="text-[10px] font-mono text-zinc-500 mt-1 truncate" data-testid="admin-user-role">
            {roleSummary}
          </div>
          <button
            onClick={logout}
            data-testid="logout-button"
            className="mt-3 w-full inline-flex items-center gap-2 text-xs text-zinc-300 hover:text-white"
          >
            <SignOut size={14} /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 bg-zinc-50">
        <PreviewBanner />
        <Outlet />
      </main>
    </div>
  );
}
